export default {"src":"/_next/static/media/CasePackIconRed.7b64d96c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};